import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import {
  ColDef,
  ValueFormatterParams,
  ValueGetterParams,
} from '@ag-grid-community/core';
import {
  CustomLiteratureDocumentListingData,
  LitCardSection,
  LiteratureDocType,
  RendererData,
} from '@types';

@Component({
  selector: 'ft-literature-custom-document-card',
  templateUrl: './literature-custom-document-card.component.html',
  styleUrls: ['./literature-custom-document-card.component.scss'],
})
export class LiteratureCustomDocumentCardComponent implements OnChanges {
  @Input() rowData: CustomLiteratureDocumentListingData;
  @Input() columnDefs: ColDef[];
  @Input() gridContext: any;
  isIntel: boolean;
  rendererData: RendererData = { data: {} };
  renderParams: any = {};
  isDocumentAvailable: boolean;
  finalRow: LitCardSection[] = [];
  literatureDocType = LiteratureDocType;
  constructor(@Inject(WINDOW) readonly windowRef: Window) {}

  ngOnChanges() {
    if (this.rowData && this.columnDefs && this.columnDefs.length > 0) {
      this.processSections();
    }
    this.rendererData = this.renderParams;
    this.rendererData.data = this.rowData;
  }
  public processSections(): void {
    this.finalRow = [];
    this.columnDefs.forEach((col) => {
      this.finalRow.push(this.processCol(col));
    });
  }

  processCol(colDef: ColDef): LitCardSection {
    const colId = colDef.colId || '';
    const label = colDef.headerName || '';
    let val;
    if (colDef.cellRendererParams) {
      this.renderParams = {
        ...colDef.cellRendererParams,
        ...this.renderParams,
      };
    }
    if (colDef.valueFormatter) {
      if (typeof colDef.valueFormatter === 'string') {
        val = colDef.valueFormatter;
      } else {
        val = colDef.valueFormatter({
          data: this.rowData,
          value: this.rowData.literatureData.frkReferenceDate,
          context: this.gridContext,
        } as ValueFormatterParams);
      }
    } else if (colDef.valueGetter) {
      if (typeof colDef.valueGetter === 'string') {
        val = colDef.valueGetter;
      } else {
        val = colDef.valueGetter({
          data: this.rowData,
          context: this.gridContext,
        } as ValueGetterParams);
      }
    } else if (colDef.cellRenderer) {
      if (typeof colDef.cellRenderer === 'string') {
        val = colDef.cellRenderer;
      } else {
        // TODO
      }
    }
    // TODO: extract caveats and tooltips
    return {
      colId,
      label,
      val,
    };
  }

  checkingDocument(colId) {
    this.isDocumentAvailable = colId in this.rendererData.data.literatureData;
  }

  openDocument(colId) {
    if (colId in this.rendererData.data.literatureData) {
      const literatutreData = this.rendererData.data.literatureData[colId];
      this.windowRef.open(literatutreData.pdfDownloadLink, '_blank');
    }
  }
}
